import { useSearchParams, useNavigate } from 'react-router-dom';
// material
import { styled } from '@material-ui/core/styles';
import { Box, Stack, Container, Typography, CircularProgress } from '@material-ui/core';
// layouts
import { useTranslation } from 'react-i18next';
import LoginForm from '../components/LoginForm';
import AuthLayout from '../layouts/AuthLayout';
// components
import Page from '../components/Page';
import { readCredentials } from '../utils/magicLink';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(12, 0)
}));

// ----------------------------------------------------------------------

export default function Magic() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();

  const credentials = readCredentials(searchParams);
  const autoLogin = searchParams.get('autoLogin') === 'true' && credentials !== null;

  const navigate = useNavigate();

  const handleSubmitSuccess = () => {
    // Replace rather than push: the entry we are leaving has the credential in its URL, and a
    // pushed entry would let the back button walk straight back into it and re-login.
    navigate('/', { replace: true });
  };

  return (
    <RootStyle title={t('pages.login')}>
      <AuthLayout>Logging in... please wait</AuthLayout>

      {autoLogin && (
        <Container maxWidth="sm">
          <ContentStyle>
            <Stack sx={{ mb: 5 }} alignItems="center">
              {/* Sized in px rather than through <Logo />, which pins maxHeight to 15vh after
                  spreading the caller's sx. With border-box that cap also has to absorb the
                  component's own 32px of vertical padding, so on a short viewport — the
                  UpGates admin embeds this page in an iframe — the logo collapses to nothing. */}
              <Box
                component="img"
                src="/static/logo_color.svg"
                alt="Recommender"
                sx={{ width: 220, maxWidth: '80%', mb: 4 }}
              />
              <Typography variant="h4" gutterBottom>
                Logging in... please wait
              </Typography>
            </Stack>

            <CircularProgress />

            <LoginForm
              defaultUsername={credentials.username}
              defaultPassword={credentials.password}
              autoLogin={autoLogin}
              onSubmitSuccess={handleSubmitSuccess}
              isHidden
            />
          </ContentStyle>
        </Container>
      )}

      {!autoLogin && (
        <Container maxWidth="sm">
          <ContentStyle>
            <Stack sx={{ mb: 5 }}>
              <Typography variant="h4" gutterBottom>
                Page not found
              </Typography>
            </Stack>
          </ContentStyle>
        </Container>
      )}
    </RootStyle>
  );
}
